import HighlightText from "./HighlightText";
import know_your_progress from "../../../assets/Images/Know_your_progress.png";
import compare_with_others from "../../../assets/Images/Compare_with_others.png";
import plan_your_progress from "../../../assets/Images/Plan_your_lessons.png";
import CTAButton from "./Button";

function LearningLanguageSection(){
    return(
        <div>
            <div className="flex flex-col gap-5 items-center">
                <div className="text-4xl font-semibold text-center">
                    Your swiss knife for<HighlightText> learning any language</HighlightText>
                </div>
                <div className="text-center text-richblack-600 mx-auto text-lg w-[70%]">
                    Using spin making learning multiple languages easy. with 20+ languages realistic voice-over, progress tracking, custom schedule and more.
                </div>

                <div className="flex flex-row items-center justify-center mt-5">
                    <img src={know_your_progress} alt="" className="object-contain -mr-32"/>
                    <img src={compare_with_others} alt="" className="object-contain"/>
                    <img src={plan_your_progress} alt="" className="object-contain -ml-36"/>
                </div>

                <div className="w-fit">
                    <CTAButton active={true} linkTo={"/signup"}>
                        Learn More
                    </CTAButton>
                </div>

            </div>
        </div>
    )
}

export default LearningLanguageSection;